module.exports = __webpack_public_path__ + "img/photo-8-1.25c8cb5e.jpg";